export const FUEL_TAP_EVENTS = {
  TAP_PLAYSTORE: 'tap_btn_download_with_playstore',
  TAP_APPSTORE: 'tap_btn_get_it_on_appstore',
  TAP_PRODUCT_LINKS: 'tap_btn_product_insurance',
  TAP_PETROL_DIESEL: 'tap_btn_fuel_type',
  TAP_STATE: 'tap_btn_state',
  TAP_CITY: 'tap_btn_city',
  TAP_ACKO_APP_FLOATER: 'tap_btn_acko_app',
}
